/**
 * @(#)2019/6/12.
 * Date，用于选择时间和日期
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { IYxInputPropTypes } from "../IpropType/basePropType";
import Date from "./Date";
import PropTypes from "prop-types";
/*
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * @param type {enum} 控件类型 date/month/range/week/time/timeRange  日期/月份/范围/周/时间/时间范围
 * @param format {string || array} 时间显示格式  默认值 YYYY-MM-DD HH:mm:ss（日期） HH:mm:ss （时间）
 * */

//类型约束

const IDateTypeProps = PropTypes.oneOf([
  "date",
  "month",
  "range",
  "week",
  "time",
  "timeRange",
]);

Date.propTypes = {
  ...IYxInputPropTypes,
  type: IDateTypeProps,
  format: PropTypes.string,
  controlType: IDateTypeProps,
};

//默认props
Date.defaultProps = {
  children: "", //子节点
  rules: {},
  inputParam: {},
  getFieldDecoratorParam: {},
  format: "", //日期默认值 YYYY-MM-DD HH:mm:ss，时间默认值 HH:mm:ss
  type: "date", // date/month/range/week/time/timeRange  日期/月份/范围/周/时间/时间范围
  styleParam: {
    width: "datesm", //宽度  xxs,xs,sm,md,lg,xl
    size: "default", //大小
    type: "default", //类型
  },
};
export default Date;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Date/index.js